import {Component} from "@angular/core";

@Component({
  selector: "success",
  templateUrl: "./success-component.template.pug",
})
export class SuccessComponent {
  messages: string[] = [];
  transclude: boolean = false;

  constructor() {}

  showSuccessMessage(message: string) {
    this.messages.push(message);
  }

  showTransclusion() {
    this.transclude = true;
  }

  hideTransclusion() {
    this.transclude = false;
  }

  closeAll() {
    this.messages = [];
  }

  close(index?: number) {
    if (index === undefined) {
      index = this.messages.length - 1;
    }

    if (index >= 0 && this.messages.length > index) {
      this.messages.splice(index, 1);
    }
  }
}
